<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--sm">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-pencil-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box-body">


                        <div class="grid grid-cols-12  gap-x-6 mt-3">


                            <div class="xl:col-span-12 col-span-12">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">ARTICLE</label>
                                <input v-if="Items.autredesignation===''" disabled type="text" :value="Items.article.libelle"
                                       class="form-control text-center" style="font-weight: bold !important;">
                                <input v-else disabled type="text" :value="Items.article.libelle+' ( '+Items.autredesignation+' )'"
                                       class="form-control text-center" style="font-weight: bold !important;">

                            </div>


                            <div class="xl:col-span-4 col-span-12">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">QUANTITE</label>
                                <input type="number" v-model="newqte" class="form-control text-center" style="font-weight: bold !important;">

                            </div>

                            <div class="xl:col-span-4 col-span-12">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">PU</label>
                                <input disabled type="number" :value="Items.pu" class="form-control text-center" style="font-weight: bold !important;">

                            </div>

                            <div class="xl:col-span-4 col-span-12">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">REMISE</label>
                                <input type="number" v-model="Items.remise" class="form-control text-center" style="font-weight: bold !important;">

                            </div>

                            <div class="xl:col-span-12 col-span-12">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">MONTANT</label>
                                <input disabled type="number" :value="montant" class="form-control text-center" style="font-weight: bold !important;">

                            </div>



                        </div>




                    </div>
                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    <button @click="selected" type="button" class="ti-btn ti-btn-primary-full">Valider</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>
</template>

<script>



    export default {
        /* eslint-disable */
        name: "formsupp",
        watch: {

            newqte: function(oldvalue,newvalue) {


                if(this.Items.article!==null ){
                    let montantpu=0;
                    let mqte=0;
                    let $puprixvente=0;
                    let mpu=0;
                    let mpa=0;
                    let $pvprices=[];

                    this.Items.qtite=parseFloat(this.newqte);


                    /*

                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente'){$puprixvente=this.ItemsArticle.article.pu;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente1'){$puprixvente=this.ItemsArticle.article.pu1;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente2'){$puprixvente=this.ItemsArticle.article.pu2;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente3'){$puprixvente=this.ItemsArticle.article.pu3;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente4'){$puprixvente=this.ItemsArticle.article.pu4;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente5'){$puprixvente=this.ItemsArticle.article.pu5;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente6'){$puprixvente=this.ItemsArticle.article.pu6;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente7'){$puprixvente=this.ItemsArticle.article.pu7;}

                    */


                    if (this.isNormalisationEtat===false){

                        $puprixvente=this.Items.article.pu;
                        $pvprices=this.Items.article.pv

                    }
                    else {

                        $puprixvente=this.Items.article.pu7;
                       // $pvprices=this.Items.article.pv7
                        $pvprices=[]
                    }


                    /*
                    if (this.isblbr===true){

                    */

                    if (this.Items.qtite!==0 ) // recherche du PU dans PV(gestion des prix tarrifaires)
                    {
                        mqte=this.Items.qtite;


                        if ($pvprices.length>0 )
                        {
                            let vm=this

                            montantpu= $puprixvente
                            $pvprices.forEach(function (line) {


                              //  if(line.mtyprix===vm.Items.jsonotherdonne.mtypprixdevente){


                                    if(parseFloat(line.min)<=parseFloat(mqte)){
                                        if(parseFloat(line.max)>=parseFloat(mqte)){

                                            montantpu=line.pu

                                        }

                                    }
                               // }
                            })


                        }
                        else{

                            // montantpu= this.itemArticle.article.pu
                            montantpu= $puprixvente
                        }

                    }
                    else{
                        // montantpu= this.itemArticle.article.pu
                        montantpu= $puprixvente

                    }

                    //***************************** le bon ok ******************************//

                    /*

                        if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                            if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                                if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                                    //let cal=   parseFloat(this.itemArticle.article.pu)/1.18
                                    let cal=   parseFloat(montantpu)/1.18
                                    // let cal=   parseFloat(this.itemArticle.article.pu)/parseFloat(this.itemArticle.article.typttc)
                                    let fixedcal=cal.toFixed(8);
                                    //this.itemArticle.pu=Math.round(cal)
                                    //this.itemArticle.pu=Math.round(fixedcal)
                                    this.ItemsArticle.pu=fixedcal
                                    this.ItemsArticle.pa=this.ItemsArticle.article.pu
                                    //this.itemArticle.pa=0

                                }
                                else{

                                    // let cal=   parseFloat(this.itemArticle.article.pu)*0.18
                                    let cal=   parseFloat(montantpu)*0.18
                                    this.ItemsArticle.pu=montantpu
                                    this.ItemsArticle.pa=Math.round(cal)

                                }



                            }
                            else{

                                // this.itemArticle.pu=this.itemArticle.article.pu
                                this.ItemsArticle.pu=montantpu
                                this.ItemsArticle.pa=this.ItemsArticle.article.pu
                                //this.itemArticle.pa=0

                            }






                        }
                        else{

                            //  this.itemArticle.pu=this.itemArticle.article.pu
                            this.ItemsArticle.pu=montantpu
                            this.ItemsArticle.pa=this.ItemsArticle.article.pu
                            //this.itemArticle.pa=0

                        }

                        */



                    this.Items.pu=montantpu
                    this.Items.pa=this.Items.article.pu




                }

            }



        },

        computed:{


            montant()
            {


                let montancalcul=0;

                if(this.Items.article!==null ){


                    if (this.Items.qtite!==0 )
                    {

                        montancalcul=parseFloat(this.Items.pu)*parseFloat(this.Items.qtite);


                    }


                    if (isNaN(this.Items.remise)) {
                        this.Items.remise=0;
                    }


                    if (this.Items.remise!==0 && !isNaN(this.Items.remise) )
                    {
                        montancalcul=montancalcul-parseFloat(this.Items.remise);
                    }

                }
                else {
                    this.Items.pu=0;
                }
                montancalcul= Math.round(montancalcul)
                this.Items.mtnt=montancalcul;

                return montancalcul


            },



        },
        components: {


        },

        data() {
            return {
                isdisplay:false,
                datavalue:"",
                titlemodal:"",
                Items:{},
                accompagnement:{},
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                myaction:"add",
                newqte:0,
                oldqte:0,
                isNormalisationEtat:false

            };
        },
        methods: {


            selected(selectprix){



                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { item: this.Items,newqte:this.newqte,
                    oldqte:this.oldqte,
                    isNormalisationEtat:this.isNormalisationEtat};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('updateqteitem', elementSelectionne);


                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },

            refreshline(){


                if(this.Items.article!==null ){
                    let montantpu=0;
                    let mqte=0;
                    let $puprixvente=0;
                    let mpu=0;
                    let mpa=0;
                    let $pvprices=[];

                    this.Items.qtite=parseFloat(this.newqte);


                    /*

                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente'){$puprixvente=this.ItemsArticle.article.pu;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente1'){$puprixvente=this.ItemsArticle.article.pu1;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente2'){$puprixvente=this.ItemsArticle.article.pu2;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente3'){$puprixvente=this.ItemsArticle.article.pu3;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente4'){$puprixvente=this.ItemsArticle.article.pu4;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente5'){$puprixvente=this.ItemsArticle.article.pu5;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente6'){$puprixvente=this.ItemsArticle.article.pu6;}
                    if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente7'){$puprixvente=this.ItemsArticle.article.pu7;}

                    */


                    if (this.isNormalisationEtat===false){

                        $puprixvente=this.Items.article.pu;
                        $pvprices=this.Items.article.pv

                    }
                    else {

                        $puprixvente=this.Items.article.pu7;
                        // $pvprices=this.Items.article.pv7
                        $pvprices=[]
                    }


                    /*
                    if (this.isblbr===true){

                    */

                    if (this.Items.qtite!==0 ) // recherche du PU dans PV(gestion des prix tarrifaires)
                    {
                        mqte=this.Items.qtite;


                        if ($pvprices.length>0 )
                        {
                            let vm=this

                            montantpu= $puprixvente
                            $pvprices.forEach(function (line) {


                                //  if(line.mtyprix===vm.Items.jsonotherdonne.mtypprixdevente){


                                if(parseFloat(line.min)<=parseFloat(mqte)){
                                    if(parseFloat(line.max)>=parseFloat(mqte)){

                                        montantpu=line.pu

                                    }

                                }
                                // }
                            })


                        }
                        else{

                            // montantpu= this.itemArticle.article.pu
                            montantpu= $puprixvente
                        }

                    }
                    else{
                        // montantpu= this.itemArticle.article.pu
                        montantpu= $puprixvente

                    }

                    //***************************** le bon ok ******************************//

                    /*

                        if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                            if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                                if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                                    //let cal=   parseFloat(this.itemArticle.article.pu)/1.18
                                    let cal=   parseFloat(montantpu)/1.18
                                    // let cal=   parseFloat(this.itemArticle.article.pu)/parseFloat(this.itemArticle.article.typttc)
                                    let fixedcal=cal.toFixed(8);
                                    //this.itemArticle.pu=Math.round(cal)
                                    //this.itemArticle.pu=Math.round(fixedcal)
                                    this.ItemsArticle.pu=fixedcal
                                    this.ItemsArticle.pa=this.ItemsArticle.article.pu
                                    //this.itemArticle.pa=0

                                }
                                else{

                                    // let cal=   parseFloat(this.itemArticle.article.pu)*0.18
                                    let cal=   parseFloat(montantpu)*0.18
                                    this.ItemsArticle.pu=montantpu
                                    this.ItemsArticle.pa=Math.round(cal)

                                }



                            }
                            else{

                                // this.itemArticle.pu=this.itemArticle.article.pu
                                this.ItemsArticle.pu=montantpu
                                this.ItemsArticle.pa=this.ItemsArticle.article.pu
                                //this.itemArticle.pa=0

                            }






                        }
                        else{

                            //  this.itemArticle.pu=this.itemArticle.article.pu
                            this.ItemsArticle.pu=montantpu
                            this.ItemsArticle.pa=this.ItemsArticle.article.pu
                            //this.itemArticle.pa=0

                        }

                        */


                    this.Items.pu=montantpu
                    this.Items.pa=this.Items.article.pu

                }

            },

            close(){

                this.isdisplay=false;


            },


            show(Items,isNormalisationEtat=false,myaction="add"){

                this.Items=Items
                this.titlemodal=(myaction==="add")?"Ajouter l'article":"Modifier la quantité de l'article"


                this.isNormalisationEtat=isNormalisationEtat
                this.myaction=myaction
                this.newqte=this.Items.qtite
                this.oldqte=this.Items.qtite

                this.refreshline();

                this.isdisplay=true;

            },


        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--sm { max-width:460px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    @media screen and (max-width: 768px) { .cf-dialog--sm { max-width:100%; } }

</style>